import { Card } from '@/components/ui/card'
import userImage from '@/assets/header/user.png'
import avatarBackground from '@/assets/dashboard/AvatarBackground.png'
import { ProfileWelcomeCardBaseProps, ProfileWelcomeCardBase } from './ProfileWelcomeCardBase'

/**
 * Mobile version of ProfileWelcomeCard
 * Uses base logic but has mobile-specific UI
 */
export const ProfileWelcomeCardMobile = ({ profile }: ProfileWelcomeCardBaseProps) => {
  const displayName = ProfileWelcomeCardBase.getDisplayName(profile)

  return (
    <div className="flex">
      <Card variant="default" className="border-0 pt-3 pb-3 px-5 relative overflow-hidden flex-1 flex flex-col bg-[rgba(255,255,255,0.7)] dark:bg-[rgba(28,28,28,0.7)]">
        <div
          className="absolute inset-0 opacity-100"
          style={{
            backgroundImage: `url(${avatarBackground})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat'
          }}
        />
        <div className="relative z-10 flex flex-col flex-1">
          {/* Mobile Layout - Horizontal: Avatar + Text */}
          <div className="flex items-center gap-[34px]">
            {/* Avatar */}
            <div className="flex-shrink-0">
              <img 
                src={userImage} 
                alt="User profile" 
                className="w-8 h-8 rounded-full object-cover"
              />
            </div>
            
            {/* Welcome Text */}
            <div className="flex flex-col items-start">
              <p className="font-plus-jakarta font-normal text-[14px] leading-[20px] text-[rgba(45,41,35,0.64)] dark:text-[rgba(253,253,253,0.64)]">
                Welcome back,
              </p>
              <h3 className="font-plus-jakarta font-bold text-[20px] leading-[24px] tracking-[-0.2px] text-[#2d2923] dark:text-[#fdfdfd]">
                {displayName}
              </h3>
            </div>
          </div>
        </div>
      </Card>
    </div>
  )
}

